//
//
//
//
//
//
//
//
//
//
//


import PowerScanner from "@/0/components/comStockOrder/comPowerScanner.vue";
import FooterButtonList from "@/0/components/comStockOrder/comFooterButtonList.vue";

export default {
  components: {
    // "flow-steps": FlowSteps,
    "power-scanner": PowerScanner,
    "footer-button-list": FooterButtonList
  },
  props: ["controlItem"],
  data() {
    return {
      
      powerScannerConfig: {
        StockOrderType: 2
      },

      buttonListConfig:{

        LeftButtonList: null,
        RightButtonList: null,

        btnScanCode: {
          action: () => {
            this.$refs.comPowerScanner.$openScan();
            return;
          }
        },
        Desc: "扫一扫极速盘库",

      },      
    };
  },

  async created() {
    // var oaOpenId = "225a333b35c96e744552faa68baad896";
    // await this.$wx.initOaConfig(oaOpenId, () => {
    //   this.$wx.hideAllNonBaseMenuItem();
    //   console.log("初始化成功");
    // });

    console.log("controlItem",this.controlItem);
    var configData = this.controlItem.ControlData;

    this.powerScannerConfig = configData;
    this.buttonListConfig.LeftButtonList = configData.LeftButtonList;
    this.buttonListConfig.RightButtonList = configData.RightButtonList;
    this.buttonListConfig.Desc = configData.Desc;

    this.controlItem.$getSubmitData = this.$getSubmitData;

    console.log("this.buttonListConfig",this.buttonListConfig);

  },

  methods: {

    $getActionObj(){

      var actionObj = this.$parent.$getActionObj();
      return actionObj;

    },

    $getSubmitData() {
      var orderOpenId = this.$refs.comPowerScanner.$getOrderOpenId();
      console.log("getSubmitData.orderOpenId",orderOpenId);
      return orderOpenId;
    },    

    async doEvent() {
      var $e = this.$cmd.checkEvent(this.controlItem, "OnChange");
      if (!$e) return;

      var $cmd = $e.Cmd;
      if (!$cmd) return;

      var url = $cmd.CommandText;
      await this.$parent.$repostForm(url);
      return;
    },

    onInput(value) {
      //console.log("onInput---value",value);
    },

    async onBlur(event) {
      console.log("onBlur---onBlur", event);
      this.doEvent();
    },

    onHelpIconClick() {
      if (this.controlItem && this.controlItem.HelperText) {
        this.$msg.toast(this.controlItem.HelperText);
      } else {
        this.$msg.toast("没有找到帮助信息");
      }
    },

    GetScanCode(){

    },


    
  }
};
